import React from "react";
import OpenAIIMG from "../../assets/app/OurAlliesSection/OPENAI.png";
import RealtimeIMG from "../../assets/app/OurAlliesSection/REAL-TIME.png";
import ClaudeIMG from "../../assets/app/OurAlliesSection/CLAUDE.png";
import AnthropicIMG from "../../assets/app/OurAlliesSection/ANTHROP.png";
import TwilioIMG from "../../assets/app/OurAlliesSection/TWILIO.png";
import HolaGPTIMG from "../../assets/app/OurAlliesSection/HOLAGPT.png";
import { useTranslation } from "react-i18next";

import "../../styles/app/OurAlliesSection.css";

const IMG = [OpenAIIMG, RealtimeIMG, ClaudeIMG, AnthropicIMG, TwilioIMG, HolaGPTIMG];

const OurAlliesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="our-allies-section">
      <h1 className="our-allies-title">{t("ourAlliesSection.title")}</h1>
      <div className="our-allies-grid">
        {IMG.map((i, index) => (
          <div className="our-allies-image">
            <img src={i} alt={index.toString()} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurAlliesSection;
